export default {
    REASONS: [
        [1, 'Will Call'],
        [2, 'Volume Discount'],
    ]
}